// 圖片到達：底色佔位＋280ms 淡入（2026-09-25 動態設計 P9）。
// 只套在縮圖類容器（作品卡、首頁精選、相關作品、作品頁圖庫）；首頁大圖與作品頁主視覺不套（它們是 LCP／形變目標）。
// 預渲染與爬蟲不啟用（html 不會帶 img-reveal，靜態 HTML 裡的圖永遠看得見）；已在快取、當下就完成的圖直接顯示不淡入。
import { isBot } from './view-transition'

const markLoaded = img => img.classList.add('is-loaded')
const onDone = event => { if (event.target instanceof HTMLImageElement) markLoaded(event.target) }

export function markCompleteImages(root = document) {
  if (!root?.querySelectorAll) return
  for (const img of root.querySelectorAll('img')) if (img.complete) markLoaded(img)
}

export function installImageReveal() {
  if (typeof document === 'undefined' || isBot()) return
  document.addEventListener('load', onDone, true)
  document.addEventListener('error', onDone, true)
  markCompleteImages(document)
  document.documentElement.classList.add('img-reveal')
}
